import React, { useState } from 'react';
import Button from '@mui/material/Button';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { CssTextField } from '../layout/elements';
import logo from '../../assets/logo.ico'
import { useAuth } from '../../hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar, Box, Stack, Divider, Grid, Paper, Typography, styled } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { auth, setCrfToken } from '../../services/user-services';
import { Cookies } from 'react-cookie';

import CaptchaUser from '../captcha/captcha';
// import config from '../../config-site';
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

export default function Login() {
    const { setAuth, authDataGroup, authDataLang } = useAuth()
    const cookies = new Cookies()
    // const [value, setValue] = useState(0)
    const [usernameLogin, setUserNameLogin ] = useState('')
    const [passwordLogin, setPasswordLogin ] = useState('')

    const [captcha, setCaptcha ] = useState('')
    const [captchaStatus, setCaptchaStatus ] = useState(true)
    
    
    // const [password, setPassword ] = useState('')
    // const [password2, setPassword2 ] = useState('')
    // const [username, setUserName ] = useState('')
    // const [last_name, setLastName ] = useState('')
    // const [email, setEmail ] = useState('')
    // const [mobileNumber, setMobileNumber ] = useState('')
    // const [address, setAddress ] = useState('')
    
    const [error, setError ] = useState(false)
    const navigate = useNavigate()

    // const passMatch = () => {
    //     return password === password2
    // }

    // const handelRegisterSubmit = async e => {
    //     e.preventDefault();
    //     if (passMatch()) {
    //         const regData = await register({last_name, username, email, password, 
    //                 profile:{is_permium: false, phone_user: mobileNumber}})
    //         if (regData) {
    //             // const data = await auth({username, password})
    //             // setAuth(data)
    //             // window.location.href = window.location.pathname
    //             navigate('/login')
    //         }else{
    //             setError(true)
    //         }
    //     }
    // }

    const handlerRegister = () => {
        navigate('/register')
    }
    
    function onChange(value) {
        setCaptcha(value)
    }

    const handleLoginSubmit = async (e) => {
        e.preventDefault();
        await auth({
            'username' : usernameLogin, 
            'password' : passwordLogin,
            'captcha_val' : captcha?.captcha_val,
            'captcha_key' : captcha?.captcha_key
        }).then(async(data) => {

            const crfAccessToken = await setCrfToken({'username' : usernameLogin, 'password' : passwordLogin})

            if (crfAccessToken?.refresh && crfAccessToken?.access){
                let dateExpire = new Date(Date.now() + (30 * 24 * 60 * 60 * 1000))
                cookies.set('refresh_token', crfAccessToken.refresh, { path: '/',  expires: dateExpire });
                cookies.set('access_token', crfAccessToken.access, { path: '/',  expires: dateExpire });
                setError(false)
                setAuth(data)
                // window.location = "/"
                if (authDataGroup?.name) {
                    navigate(`/${authDataGroup.name}`)
                } else {
                    navigate(`/`)
                }
                // navigate(-1)
            }else{
                setError(true)
                navigate(`/logout`)
            }
            setCaptchaStatus(true)
        })
        .catch((err) =>{
            setError(true)
            setCaptchaStatus(true)
        })
    };
  
    // const handleChange = (event, newValue) => {
    //     setValue(newValue)
    // };
    
    // useEffect( () => {
    //     window.scrollTo(0, 200)
    // }, [])

    return (
        <Box
          sx={{
            bgcolor: 'background.default',
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Paper elevation={6} sx={{ maxWidth: 500, width: '100%', borderRadius: 4, p: 4 }}>
            <Stack spacing={3} alignItems="center">
              <Avatar
                src={logo}
                sx={{ width: 100, height: 100 }}
                alt="logo etec"
              />
              <Typography variant="h4" fontFamily="vaziri" color="primary">
                ورود به حساب
              </Typography>
      
              <Divider sx={{ width: '100%' }} />
      
              {/* نام کاربری */}
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <AccountCircle color="action" />
                </Grid>
                <Grid item xs>
                  <CssTextField
                    label={
                      <Typography fontFamily="vaziri_light" variant="h6">
                        {authDataLang?.site_langs?.desc_user_name}
                      </Typography>
                    }
                    variant="standard"
                    fullWidth
                    onChange={e => setUserNameLogin(e.target.value)}
                  />
                </Grid>
              </Grid>
      
              {/* رمز عبور */}
              <Grid container spacing={1} alignItems="flex-end">
                <Grid item>
                  <VpnKeyIcon color="action" />
                </Grid>
                <Grid item xs>
                  <CssTextField
                    label={
                      <Typography fontFamily="vaziri_light" variant="h6">
                        {authDataLang?.site_langs?.desc_password}
                      </Typography>
                    }
                    type="password"
                    variant="standard"
                    fullWidth
                    onChange={e => setPasswordLogin(e.target.value)}
                  />
                </Grid>
              </Grid>
      
              {/* کپچا */}
              <Box sx={{ alignSelf: 'stretch', textAlign: 'right', mt: 2 }}>
                <CaptchaUser onBack={onChange} reqCaptch={captchaStatus} />
              </Box>
      
              {/* دکمه ورود */}
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                disabled={!usernameLogin || !passwordLogin || !captcha}
                onClick={handleLoginSubmit}
                sx={{ mt: 1 }}
              >
                <Typography fontFamily="Segoe UI" variant="h6">
                  {authDataLang?.site_langs?.desc_menu_login}
                </Typography>
              </Button>
      
              {/* فراموشی رمز */}
              <Box sx={{ width: '100%', textAlign: 'left' }}>
                <Link to="/">
                  <Typography variant="body2" color="secondary" fontFamily="Segoe UI">
                    {authDataLang?.site_langs?.desc_forget_password}
                  </Typography>
                </Link>
              </Box>
      
              <Divider sx={{ width: '100%' }} />
      
              {/* بخش ثبت نام */}
              <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                <Grid item xs={7}>
                  <Link to="/register">
                    <Typography fontFamily="Segoe UI" variant="body1" color="primary">
                      آیا می‌خواهید حساب جدید باز کنید؟
                    </Typography>
                  </Link>
                </Grid>
                <Grid item xs={5} sx={{ textAlign: 'right' }}>
                  <Button variant="outlined" color="primary" onClick={handlerRegister}>
                    <Typography fontFamily="Segoe UI" variant="body1">
                      ثبت‌نام
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
      
              {/* ارور لاگین */}
              {error && (
                <Box mt={2} width="100%">
                  <Divider />
                  <Typography variant="body1" fontFamily="Segoe UI" color="error">
                    {authDataLang?.site_langs?.desc_msg_wrong_pass}
                  </Typography>
                </Box>
              )}
            </Stack>
          </Paper>
        </Box>
      );
      
}
  
